
import React, { useState, useEffect } from "react";
import MultiSelector from "./MultiSelector";

function StartSelector({passData, TransportMeansSelection}) {
    
    const [StartSelectorOptions, setStartSelectorOptions] = useState([])
    

    let url = "";

    switch (TransportMeansSelection[0]) {
        case 'Οδικές':
          url = '/api/roadtransport/zones_origins';
          break;
        case 'Αεροπορικές':
          url = '/api/airtransport/origins';
          break;
        case 'Θαλάσσιες':
          url = "/api/marinetransport/origins";
          break;
        case 'Σιδηροδρομικές':
          url = '/api/railtransport/origins';
        break;
        default:
          console.log('The selected value is not an option');
      }
      
      console.log("URL",url)
    useEffect(() => {
      console.log("Before fetch")
        fetch(url).then((res) =>
           res.json().then((res) => {
            let OriginValues = res.data.Origins
            
            const StartSelectorOptionValues = []
            for (let i = 0; i < OriginValues.length; i++) {
                StartSelectorOptionValues.push({key: OriginValues[i]})
            }


            let StartSelectorProps = {
                title: "0.3 Προέλευση",
                options: StartSelectorOptionValues
                // options: [{key: 'Αθήνα(ATH)'},{key: 'Σαλόνικα(SKG)'}]
            }
            setStartSelectorOptions(StartSelectorProps)

          })
        )
        .catch((error) => {
          console.log("Refetching data for Origins!")
        });
      }, [url]);




    return (
        //TODO isws props.passData
        <MultiSelector passData = {passData} props = {StartSelectorOptions} selectionsLimit = {1}/>
    
    );
}

export default StartSelector;
